import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logoutAdmin, checkAdminAuth, handleAdminAuthError } from '../utils/auth';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const initAdmin = async () => {
      try {
        await checkAdminAuth();
      } catch (error) {
        handleAdminAuthError(error);
      }
    };

    initAdmin();
  }, [navigate]);

  const handleLogout = () => {
    logoutAdmin();
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <div className="admin-header__logo">
          <img src="/assets/img/logo.svg" alt="Pro Investor" />
        </div>
        <div className="admin-header__title">Админ-панель</div>
        <div className="admin-header__actions">
          <button className="admin-header__logout" onClick={handleLogout}>
            <span className="--icon-log-out"></span>
            Выйти
          </button>
        </div>
      </div>

      <div className="admin-content">
        <div className="admin-welcome">
          <h1 className="admin-title">Добро пожаловать в админ-панель</h1>
          <p className="admin-subtitle">Управляйте пользователями, счетами и операциями</p>
          
          <div className="admin-navigation">
            <div className="admin-nav-grid">
              <div className="admin-nav-card" onClick={() => navigate('/admin/users')}>
                <div className="admin-nav-card__icon --icon-profile"></div>
                <h3>Пользователи</h3>
                <p>Управление пользователями и их ролями</p>
              </div>
              
              <div className="admin-nav-card" onClick={() => navigate('/admin/bank-accounts')}>
                <div className="admin-nav-card__icon --icon-account"></div>
                <h3>Банковские счета</h3>
                <p>Управление банковскими счетами</p>
              </div>
              
              <div className="admin-nav-card" onClick={() => navigate('/admin/trading-accounts')}>
                <div className="admin-nav-card__icon --icon-wallet"></div>
                <h3>Торговые счета</h3>
                <p>Управление торговыми счетами</p>
              </div>
              
              <div className="admin-nav-card" onClick={() => navigate('/admin/deposits')}>
                <div className="admin-nav-card__icon --icon-deposit"></div>
                <h3>Пополнения</h3>
                <p>Управление операциями пополнения</p>
              </div>
              
              <div className="admin-nav-card" onClick={() => navigate('/admin/withdrawals')}>
                <div className="admin-nav-card__icon --icon-withdraw"></div>
                <h3>Вывод средств</h3>
                <p>Управление операциями вывода</p>
              </div>
              
              <div className="admin-nav-card" onClick={() => navigate('/admin/profits')}>
                <div className="admin-nav-card__icon --icon-history"></div>
                <h3>Доходы</h3>
                <p>Управление доходами пользователей</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;